import * as React from "react";

function SvgCheckIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" {...props}><path d="M173.8 28.4L60.4 141.8 15.7 97.2 5.1 107.8 60.4 163l124-124-10.6-10.6z" /></svg>;
}

export default SvgCheckIcon;